import { render, staticRenderFns } from "./DeviceRealTimeTemplateChart.vue?vue&type=template&id=1c39b206&scoped=true"
import script from "./DeviceRealTimeTemplateChart.vue?vue&type=script&lang=js"
export * from "./DeviceRealTimeTemplateChart.vue?vue&type=script&lang=js"
import style0 from "./DeviceRealTimeTemplateChart.vue?vue&type=style&index=0&id=1c39b206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c39b206",
  null
  
)

export default component.exports